import React from 'react';
import Btn from '../../../components/ui/Btn';
import StatusTag from '../../../components/ui/StatusTag';
import { CHANNEL_NAMES } from '../../../utils/agentReadiness';

const ACTIVE = ['connected', 'degraded'];
const when = (iso) => (iso ? new Date(iso).toLocaleString('es-MX', { dateStyle: 'medium', timeStyle: 'short' }) : null);

function Row({ label, children, action }) {
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 py-3.5 border-t border-line first:border-0">
      <dt className="w-40 shrink-0 text-[13px] text-fg-faint">{label}</dt>
      <dd className="flex-1 min-w-0 text-[14px] text-fg flex flex-wrap items-center gap-2">{children}</dd>
      {action}
    </div>
  );
}

const channelLabel = (c) => c.channel === 'telegram' && c.external?.username ? `Telegram @${c.external.username}`
  : c.channel === 'whatsapp' && c.external?.display_phone_number ? `WhatsApp ${c.external.display_phone_number}`
  : CHANNEL_NAMES[c.channel] || c.channel;

// Resumen de la ficha: la puesta en marcha arriba, el estado en una lista corta y las acciones delicadas al final.
export default function AgentOverview({ agent, project, published, connections, credential, archived, readinessView, onGo, onArchive, onRestore, onExternal }) {
  const live = connections.filter((c) => ACTIVE.includes(c.status) || c.channel === 'web');
  const broken = connections.filter((c) => c.status === 'error');
  return (
    <div className="space-y-8">
      {readinessView}

      <dl className="rounded-2xl bg-panel ring-1 ring-line px-5">
        <Row label="Canales" action={<Btn size="sm" variant="ghost" onClick={() => onGo('canales')}>Ver canales</Btn>}>
          {live.length ? live.map((c) => <StatusTag key={c.id} tone="live" dot>{channelLabel(c)}</StatusTag>) : <span className="text-fg-dim">Ninguno conectado</span>}
          {broken.map((c) => <StatusTag key={c.id} tone="caution">{channelLabel(c)} con error</StatusTag>)}
        </Row>
        <Row label="Versión en uso" action={<Btn size="sm" variant="ghost" onClick={() => onGo('versiones')}>Ver versiones</Btn>}>
          {agent.published_version ? <>Versión {agent.published_version}{when(published?.published_at) && <span className="text-fg-faint text-[13px]">· {when(published.published_at)}</span>}</> : <span className="text-fg-dim">Ninguna: solo hay borrador</span>}
        </Row>
        <Row label="Clave de OpenAI" action={<Btn size="sm" variant="ghost" onClick={() => onGo('clave')}>{credential ? 'Cambiar' : 'Agregar'}</Btn>}>
          {credential?.status === 'error' ? <StatusTag tone="caution">OpenAI la rechazó</StatusTag> : credential ? <>Termina en <span className="font-mono">{credential.last4}</span></> : <span className="text-fg-dim">Sin clave</span>}
        </Row>
        <Row label="Motor del proyecto">
          {project?.engine === 'runtime' ? <StatusTag tone="live" dot>Encendido</StatusTag> : <span className="text-fg-dim">Apagado: «{project?.name}» lo atiende n8n</span>}
        </Row>
      </dl>

      <div className="rounded-2xl ring-1 ring-line px-5 py-4">
        <h3 className="text-[14px] font-semibold text-fg">Otras acciones</h3>
        <div className="mt-3 flex flex-col gap-3">
          <div className="flex flex-wrap items-center gap-3">
            <p className="flex-1 min-w-[16rem] text-[13px] text-fg-dim">{archived ? 'Está archivado: no responde. Al restaurarlo vuelve como borrador.' : 'Archivar lo deja de hacer responder; sus versiones y su historial se conservan.'}</p>
            {archived ? <Btn size="sm" onClick={onRestore}>Restaurar</Btn> : <Btn size="sm" variant="ghost" onClick={onArchive}>Archivar</Btn>}
          </div>
          {onExternal && <div className="flex flex-wrap items-center gap-3 pt-3 border-t border-line">
            <p className="flex-1 min-w-[16rem] text-[13px] text-fg-dim">Si este agente en realidad funciona en n8n u otro sistema, márcalo como externo: queda registrado sin puesta en marcha.</p>
            <Btn size="sm" variant="ghost" onClick={onExternal}>Marcar como externo</Btn>
          </div>}
        </div>
      </div>
    </div>
  );
}
